/**
 * Хиксът за изчистване (`showClear`) на PrimeNG е бутон навсякъде (#431).
 *
 * PrimeNG рисува хикса като `<svg>` само с `(click)`: не е в реда на Tab, няма
 * роля и име, а при autocomplete/multiselect е и `aria-hidden`. Поправката е тук,
 * на едно място, през глобалния pass-through (`providePrimeNG({ pt })`), а не по
 * шаблоните: всяко поле с `[showClear]` я получава само. Курсорът и фокусът са в
 * `styles.scss` (блокът „Хиксът за изчистване“).
 *
 * Клавиатурата не пише своя логика за чистене: Enter/интервал правят същото
 * щракване, което прави и мишката, после фокусът се връща в полето — хиксът
 * изчезва заедно със стойността и иначе фокусът би паднал в `<body>`.
 */
export function clearIconPassThrough(label: string) {
  const clearIcon = {
    role: 'button',
    tabindex: '0',
    'aria-label': label,
    'aria-hidden': 'false',
    onKeydown: onClearIconKeydown,
  };
  return {
    select: { clearIcon },
    autocomplete: { clearIcon },
    multiselect: { clearIcon },
    inputnumber: { clearIcon },
    // Datepicker-ът подава на хикса секцията `inputIcon`. Същата секция има и
    // иконата-календар при `iconDisplay="input"`; тя се пропуска, за да не стане
    // „Изчисти“ бутон, който отваря календара.
    datepicker: {
      inputIcon: ({ instance }: { instance?: { iconDisplay?: string } }) => (instance?.iconDisplay === 'input' ? undefined : clearIcon),
    },
  };
}

function onClearIconKeydown(event: KeyboardEvent): void {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  event.stopPropagation();
  const icon = event.currentTarget as Element;
  const field = icon.closest('[data-pc-name]');
  icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  field?.querySelector<HTMLElement>('input:not([type="hidden"]), [role="combobox"]')?.focus();
}
